import React, { useState } from 'react';
import Paper from '@mui/material/Paper';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import FormLabel from '../common/form/FormLabel';
import koLocale from 'date-fns/locale/ko';
import DateAdapter from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import DatePicker from '@mui/lab/DatePicker';
import Draggable from 'react-draggable';

import BootstrapDialog, {
  BootstrapDialogTitle,
} from '../common/dialog/BootstrapDialog';
import { useRef } from 'react';

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-emp-dialog"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const EstimateEditModal = ({ open, handleClose, onSave, currentData }) => {
  const dateFocus = useRef();

  const [qteRegDt, setQteRegDt] = useState(currentData?.qteRegDt || new Date());

  const handleSave = () => {
    if (qteRegDt === null || qteRegDt === '') {
      alert('견적일자를 입력하세요');
      dateFocus.current.focus();
      return;
    }

    onSave(qteRegDt);
    handleClose();
  };

  if (!currentData) {
    return null;
  }

  return (
    <BootstrapDialog
      open={open}
      onClose={handleClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-emp-dialog"
      fullWidth={true}
      maxWidth="sm"
    >
      <BootstrapDialogTitle
        style={{ cursor: 'move' }}
        id="draggable-emp-dialog"
        onClose={handleClose}
      >
        {currentData?.cstNm} 수정
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{
            py: 1,
          }}
        >
          <Grid item xs={4}>
            <FormLabel>
              견적일자
              <Typography
                variant="subtitle2"
                component="span"
                sx={{ mx: 1, color: 'error.main' }}
              >
                (필수)
              </Typography>
            </FormLabel>
          </Grid>
          <Grid item xs={8}>
            <LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
              <DatePicker
                inputFormat={'yyyy-MM-dd'}
                mask={'____-__-__'}
                id="qteRegDt"
                name="qteRegDt"
                value={qteRegDt}
                onChange={(newValue) => {
                  setQteRegDt(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    sx={{ width: 180 }}
                    variant="outlined"
                    size="small"
                    required={true}
                    fullWidth
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <Button variant="outlined" color="inherit" onClick={handleClose}>
          취소
        </Button>
        <Button variant="contained" onClick={handleSave}>
          저장
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default EstimateEditModal;
